import React, {PureComponent} from "react"

import {FormattedMessage, FormattedCurrency, injectIntl, InjectIntl} from "@irati/utils/lang"
import {ReduxState} from "@irati/store/types"
import connect from "@irati/store/connect"
import id from "@irati/utils/id"
import RewardWalletBalanceQuery from "@irati/wallet/apollo/query/RewardWallet"
import RewardsQueryComponent, {RewardsData} from "@irati/reward/apollo/query/Rewards"
import {RewardStatus} from "@irati/reward/enums"
import tracking from "@irati-tracking/wallet/rewardWallet"
import {H3} from "@irati/ui/src/Headings"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {
  CreditWrapper,
  CreditAsRewardWrapper,
  Balances,
  Balance,
  StyledButton,
  StyledCard,
  StyledCaption,
  AvailableBalance}
  from "./styled"

interface Props extends InjectIntl {
  isMobile: boolean
}

class RewardWalletBannerCard extends PureComponent<Props> {
  returnVariables = () => ({
    limit: 12,
    status: RewardStatus.ON,
    sortBy: "createdAt",
    sortDir: "DESC",
    rewardsForMyPackage: true,
    isCreditOnly: true
  })

  returnCreditReward = ({rewardCatalogueRewards}: RewardsData) => {
    const {results} = rewardCatalogueRewards

    if (results.length > 0) {
      const creditReward = results[0]
      return creditReward
    }

    return undefined
  }

  handleSendCredit = () => {
    tracking.startRewardWalletSendCredit()
  }

  render() {
    const {isMobile} = this.props
    const IconSize = isMobile ? 20 : 25
    const idNamespace = id("reward-wallet-banner", this.props)
    const variables = this.returnVariables()

    return (
      <RewardWalletBalanceQuery>
        {({data}) => {
          const {availableBalance, currency} = data.rewardWallet
          const hasBalance = availableBalance > 0

          if (!hasBalance) { return null }
          return (
            <RewardsQueryComponent variables={variables}>
              {(res) => {
                const creditReward = this.returnCreditReward(res.data)
                return (
                  <StyledCard id={idNamespace}>
                    <CreditWrapper fullWidth={!creditReward}>
                      <Balances>
                        <Balance id={id("available-balance", idNamespace)}>
                          <H3 bold>
                            <Icon icon={IconTypes.wallet} size={IconSize} marginRight />
                            <FormattedMessage id="reward.banner.wallet.header" />
                          </H3>
                          <StyledCaption flush>
                            <FormattedMessage id="reward.banner.wallet.available" />
                          </StyledCaption>
                          <AvailableBalance>
                            <FormattedCurrency isCents={false} currency={currency} value={availableBalance} />
                          </AvailableBalance>
                        </Balance>
                      </Balances>
                    </CreditWrapper>
                    {creditReward &&
                      <CreditAsRewardWrapper>
                        <StyledButton primary to={`/reward/${creditReward.urlSlug}`} onClick={this.handleSendCredit}>
                          <FormattedMessage id="reward.banner.wallet.sendLink" />
                        </StyledButton>
                      </CreditAsRewardWrapper>
                    }
                  </StyledCard>
                )
              }}
            </RewardsQueryComponent>
          )
        }}
      </RewardWalletBalanceQuery>
    )
  }
}

const mapStateToProps = ({mq}: ReduxState) => ({
  isMobile: mq.lessThan.md
})

export default injectIntl(connect(mapStateToProps)(RewardWalletBannerCard))
